module.exports = __webpack_public_path__ + "media/images/icons/community-c710b6bd9d5ae29ee392ac05c739e080.svg";